import { render, staticRenderFns } from "./modal-escoger.vue?vue&type=template&id=6741a9de&scoped=true"
import script from "./modal-escoger.vue?vue&type=script&lang=js"
export * from "./modal-escoger.vue?vue&type=script&lang=js"
import style0 from "./modal-escoger.vue?vue&type=style&index=0&id=6741a9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741a9de",
  null
  
)

export default component.exports